import AuthorsApi from '@/frontend/api/authors';
import WorksApi from '@/frontend/api/works';
export default {
  name: "WorksFilterComponent",

  data() {
    return {
      WorksFilter: this.getDefaultWorksFilter()
    };
  },

  computed: {
    formattedFilterAuthors() {
      let result = {};
      if (!this.WorksFilter.authors.result.length) return result;
      this.WorksFilter.authors.result.forEach(item => {
        let char = item.name[0];
        if (!Array.isArray(result[char])) result[char] = [];
        result[char].push(item);
      });
      return result;
    },

    formattedFilterYears() {
      if (!this.WorksFilter.years.search) return this.WorksFilter.years.result;
      return this.WorksFilter.years.result.filter(string => string.indexOf(this.WorksFilter.years.search) !== -1);
    }

  },
  methods: {
    getDefaultWorksFilter() {
      return {
        authors: {
          selected: [],
          search: [],
          result: []
        },
        years: {
          selected: [],
          search: [],
          result: []
        }
      };
    },

    resetWorksFilter() {
      this.resetWorksFilterAuthors(false);
      this.resetWorksFilterYears(false);
      this.emitFilter();
    },

    resetWorksFilterAuthors(filtered = true) {
      this.WorksFilter.authors = this.getDefaultWorksFilter().authors;
      this.searchAuthors();
      filtered && this.emitFilter();
    },

    resetWorksFilterYears(filtered = true) {
      this.WorksFilter.years.selected = [];
      this.WorksFilter.years['search'] = [];
      filtered && this.emitFilter();
    },

    emitFilter() {
      this.$emit('filtered', this.WorksFilter.authors.selected, this.WorksFilter.years.selected);
    },

    searchAuthors() {
      let params = {};
      if (this.WorksFilter.authors.search) params['filter[name][like]'] = this.WorksFilter.authors.search;
      params['sort'] = 'name';
      params['per-page'] = 100000;
      AuthorsApi.get(params).then(response => this.WorksFilter.authors.result = response.items);
    },

    initYears() {
      WorksApi.getYears().then(response => this.WorksFilter.years.result = Object.values(response));
    }

  },

  created() {
    this.searchAuthors();
    this.initYears();
  }

};